import * as tf from '@tensorflow/tfjs';
import * as tmPose from '@teachablemachine/pose';
import {save} from './saveTmModel.js'
import {createPoseModel, estimateAndDraw} from './tmPosenet.js'
import {toRaw} from 'vue'

export default class CustomTmPose{
    constructor(){
        this.model = null
        this._stopTraining = false
    }

    async train(labels, data, params = {
            denseUnits: 100,
            epochs: 50,
            learningRate: 0.001,
            batchSize: 16
        }, callback = () => {}){

        this._stopTraining = false;
        let model = await createPoseModel();
        model.setLabels(labels)
        await this.addData(model, data)

        await model.train(params, {
            onEpochEnd: async (epoch, logs) => {
                const realEpoch = epoch + 1
                callback(`Epoch: ${realEpoch} / ${params.epochs}`, realEpoch / params.epochs)
                console.log("Epoch: ", realEpoch);

                if (this._stopTraining) {
                    model.stopTraining().then(() => {
                        console.log("Stopped training early");
                        callback(``, 1)
                    });
                }
            }
        })

        model = new tmPose.CustomPoseNet(model.model, model.posenetModel, model._metadata);
        model._metadata.modelName = 'my-pose-model'
        await this.loadRaw(model)
        return this.model
    }

    stopTraining(){
        this._stopTraining = true;
    }

    async save(){
        return await save(toRaw(this.model.model), this.model._metadata)
    }

    async addData(model, dataset){
        for(let i = 0; i < dataset.length; i++){
            for(let j = 0; j < dataset[i].length; j++){
                const posenetOutput = dataset[i][j]
                await model.addExample(i, posenetOutput)
                if  (dataset[i].length == 1) {
                    await model.addExample(i, posenetOutput) //posenet need at least 2 samples
                }
            }
        }
    }

    async loadUrl({modelUrl, metadataUrl}){
        await this.loadRaw(Object.freeze(await tmPose.load(modelUrl, metadataUrl)))
    }

    async loadFile({modelFile, metadataFile, weightsFiles}){
        await this.loadRaw(Object.freeze(await tmPose.loadFromFiles(modelFile, weightsFiles[0], metadataFile)))
    }

    async loadRaw(model){
        this.model = model;
        /* this.$emit('start', this.model._metadata.labels) */
    }

    async predict(canvas, canvasToDraw){
        let result = null
        const { pose, posenetOutput } = await estimateAndDraw(canvas);

        if(pose && canvasToDraw){
            const ctx = canvasToDraw.getContext('2d')
            if(ctx){
                const minPartConfidence = 0.5;
                ctx.clearRect(0, 0, canvasToDraw.width, canvasToDraw.height);
                tmPose.drawKeypoints(pose.keypoints, minPartConfidence, ctx);
                tmPose.drawSkeleton(pose.keypoints, minPartConfidence, ctx);
            }
        }

        if(posenetOutput && this.model) {
            result = await this.model.predict(posenetOutput);
        }

        return {result, pose ,posenetOutput}
    }

    async test(){
        const url = "https://teachablemachine.withgoogle.com/models/HjzJDNeDL/"
        const modelUrl = url + "model.json";
        const metadataUrl = url + "metadata.json";
        await this.loadUrl({modelUrl: modelUrl, metadataUrl: metadataUrl})
        return this
    }
}